<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.entrance']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceId">
<!--              <j-dict-select-tag type="list" v-model="model.entranceId" dictCode="" :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']" />-->
              <a-select v-model="model.entranceId" @change="entranceChange" :disabled="this.$store.getters.applicationCode != 'emp_platform'"
                        :placeholder="language['common.pleaseChoose']+language['emp.col.entrance.entranceName']" allowClear>
                <a-select-option v-for="(item,index) in entrances" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.apptypeCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="appTypeCode">
              <a-input v-model="model.appTypeCode" :placeholder="language['common.pleaseInput']+language['emp.apptype.apptypeCode']" maxLength=35  :disabled="formDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.apptypeName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="appTypeName">
              <a-input v-model="model.appTypeName" :placeholder="language['common.pleaseInput']+language['emp.apptype.apptypeName']" maxLength=50 style="width: 85%" :disabled="formDisabled"></a-input>
              <a-button @click="languageModelOpen('emp_base_apptype','app_type_name',apptypeLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imgPath">
              <j-image-upload v-model="model.imgPath" :text="this.language['common.uploadButton']" :disabled="formDisabled"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishStatus">
              <j-dict-select-tag type="radio" v-model="model.publishStatus" :trigger-change="true" dictCode="sys_portal_up_down" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.publishPersion']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publisher">
              <a-input v-model="model.publisher" placeholder=""  :readOnly="true" disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.publishTime']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishTime">
              <j-date placeholder="" v-model="model.publishTime"  style="width: 100%" :readOnly="true" date-format="YYYY-MM-DD HH:mm:ss" />
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.sort']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" :placeholder="language['common.pleaseInput']+language['emp.apptype.sort']" style="width: 100%" :min="1" :max="999999" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item label="刪除标示" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="delFlag">
              <a-input v-model="model.delFlag" placeholder="请输入刪除标示"  ></a-input>
            </a-form-model-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea :placeholder="language['common.pleaseInput']+language['basedata.remark']" v-model="model.remark" :maxLength="ml" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['portal.unitApp']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="selectedApps">
              <j-multi-select-tag :maxTagCount="20"
                v-model="model.selectedApps"
                :options="appsOptions"
                :placeholder="language['common.pleaseChoose']+language['portal.unitApp']" :disabled="formDisabled">
              </j-multi-select-tag>
            </a-form-model-item>
          </a-col>

        </a-row>
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import LanguageModel from "@/components/LanguageModel"

  export default {
    name: 'EmpBaseApptypeForm',
    components: {
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        /*validatorRules: {

        },*/
        url: {
          add: "/hhemp/apptype/empbaseapptype",
          edit: "/hhemp/apptype/empbaseapptype",
          queryById: "/hhemp/apptype/empbaseapptype/",
          doDuplicateCheck:"/hhemp/apptype/doDuplicateCheck",
        },
        entrances:[{
          id:'',
          colName:'',
          entranceName:''
        }],
        apptypeLanguages:[],
        appsOptions:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        return {
          entranceId: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.apptype.entrance'] + '!'},
          ],
          appTypeCode: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.apptype.apptypeCode'] + '!'},
            { validator: (rule, value, callback) => validateDuplicateValue('emp_base_apptype', 'app_type_code', value, this.model.id, '0', callback)},
          ],
          appTypeName: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.apptype.apptypeName'] + '!'},
            {validator: this.validateApptypeName,}
          ],
          publishStatus: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.apptype.status'] + '!'},
          ],
          /*delFlag: [
            { required: true, message: '请输入刪除标示!'},
          ],*/

        }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.initAppList();
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.getEntranceList();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.hasOwnProperty("id")){
          this.getAppTypeApps(record.id);
          this.initLanguagetemp('emp_base_apptype','app_type_name',record.id)
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                /*that.$message.success(res.message);
                that.$emit('ok');*/
                this.apptypeLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.apptypeLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.submitCallback();
                    that.confirmLoading = false;
                  }
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      getEntranceList(){
        httpAction("/hhemp/entrance/empcmsentrances?status=Y", "", "get").then((res) => {
          if (res.success) {
            this.entrances = res.result;
            if(this.$store.getters.applicationCode != 'emp_platform') {
              this.entrances.forEach(item => {
                if (item.entranceCode === this.$store.getters.applicationCode) {
                  this.model.entranceId = item.id;
                }
              });
            }
          }
        })
      },
      validateApptypeName(rule, value, callback){
        let params = {
          appTypeName: value,
          id:this.model.id,
          entranceId: this.model.entranceId
        };
        getAction(this.url.doDuplicateCheck,params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(this.language['emp.apptype.apptypeName']+this.language['common.alreadyExists']+"!")
          }
        })
      },
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("hhemp",dataTable,dataColumn,this.model.id,languagelist,this.disableSubmit);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'app_type_name'){
          this.apptypeLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "hhemp",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.apptypeLanguages = res.result;
          }
        })
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllAppsContainThird?applicationStatus=1").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
          }
        })
      },
      getAppTypeApps(appTypeId){
        getAction("/sys/portal/sysPortalOrg/getAppTypeApps",{id:appTypeId}).then((res)=>{
          if(res.success){
            this.model.selectedApps = res.result.join(",");
          }
        })
      },
    }
  }
</script>
